export default __webpack_public_path__ + "static/media/stamp_paper_home.ffcd2813.png";